<script lang="ts">import { Button } from "@infinitro/button";
import { cfgToThemeCdnPath } from "@infinitro/config";
import { t, Verbiage } from "@infinitro/content";
import { locale, loggedIn, ModalDialog, pushModal } from "@infinitro/global";
import TopCard from "./top-card.svelte";
export let isBigScreen = false;
const signupClick = () => {
	pushModal(ModalDialog.Auth, { tab: "signup" });
};
$: backgroundImage = $loggedIn === false ? cfgToThemeCdnPath("/top-section/big-left-public.png") : cfgToThemeCdnPath("/top-section/main-default.png");
$: welcomeOfferHtml = $t(Verbiage.welcome_offer).toUpperCase().replace("275%", `<span style="color: var(--color-highlight-2)">275%</span><br />`);
</script>

<div class="top-card-container">
	<TopCard {backgroundImage} height="100%" width="100%" />
	{#if $loggedIn === false}
		<div class="content-top-card">
			<div class="content-top-card-container">
				<div>
					<h2 class="card-section-title">
						{@html welcomeOfferHtml}
					</h2>
					<div class="description-container">
						<p class="card-section-subtitle">
							<span>{$t(Verbiage.welcome_description)}</span>
						</p>
					</div>
				</div>
				<!-- 				<div class="description-container-hidden">
					<div class="hidden-text">
						<p class="card-section-body">
							{$locale === 'en'
								? $t(Verbiage.play_online).split(' ').slice(0, 5).join(' ')
								: $t(Verbiage.play_online)}
							{#if $locale === 'en'}
								<br />
							{/if}
							{$locale === 'en' ? $t(Verbiage.play_online).split(' ').slice(5, 12).join(' ') : ''}
							{#if $locale === 'en'}
								<br />
							{/if}
							{$locale === 'en' ? $t(Verbiage.play_online).split(' ').slice(12).join(' ') : ''}
						</p>
					</div>
				</div> -->
				{#if $loggedIn === false}
					<Button
						fullWidth
						onClick={signupClick}
						size={isBigScreen ? 'large' : 'small'}
						text={$t(Verbiage.join_now)}
					/>
				{/if}
			</div>
		</div>
	{/if}
	<!-- <img alt={$t(Verbiage.illustration_alt, 'alts')} class="chip-green-1" src={`${CDN_BASE}/top-main-chip-green-1-x2.png`} />
	<img alt={$t(Verbiage.illustration_alt, 'alts')} class="chip-green-2" src={`${CDN_BASE}/top-main-chip-green-2-x2.png`} />
	<img alt={$t(Verbiage.illustration_alt, 'alts')} class="chip-yellow-1" src={`${CDN_BASE}/top-main-chip-yellow-1-x2.png`} />
	<img alt={$t(Verbiage.illustration_alt, 'alts')} class="chip-yellow-2" src={`${CDN_BASE}/top-main-chip-yellow-2-x2.png`} />
	<img alt={$t(Verbiage.illustration_alt, 'alts')} class="chip-yellow-3" src={`${CDN_BASE}/top-main-chip-yellow-3-x2.png`} />
	<img alt={$t(Verbiage.illustration_alt, 'alts')} class="chip-yellow-4" src={`${CDN_BASE}/top-main-chip-yellow-4-x2.png`} />
	<img alt={$t(Verbiage.illustration_alt, 'alts')} class="diamond-blue" src={`${CDN_BASE}/top-main-diamond-blue-x2.png`} />
	<img
		alt={$t(Verbiage.illustration_alt, 'alts')}
		class="diamond-yellow"
		src={`${CDN_BASE}/top-main-diamond-yellow-x2.png`}
	/> -->
</div>

<style>
	.content-top-card {
		position:
			absolute;
		z-index:
			40;
		display:
			flex;
		height:
			100%;
		width:
			100%;
		align-items:
			flex-end;
		justify-content:
			space-between;
		padding:
			1rem;
}

	@media (min-width: 1280px) {
		.content-top-card {
				padding:
			0.75rem;
		}
	}

	@media (min-width: 1440px) {
		.content-top-card {
				padding:
			1.25rem;
		}
	}

	.content-top-card-container {
		position:
			relative;
		display:
			flex;
		height:
			100%;
		width:
			100%;
		flex-direction:
			column;
		align-items:
			flex-start;
		justify-content:
			space-between;
		overflow:
			hidden;
}

	.top-card-container {
		position:
			relative;
		display:
			flex;
		height:
			100%;
		width:
			100%;
		align-items:
			center;
		justify-content:
			space-between;
}

	.top-card-container img {
		position:
			absolute;
		z-index:
			10;
}

	.description-container {
		margin-bottom:
			0.25rem;
}

	@media (min-width: 640px) {

		.description-container {
				margin-top:
			0.25rem;
				margin-bottom:
			0.25rem;
		}
}

	.description-container-hidden {
		position:
			relative;
		margin-bottom:
			0.5rem;
		height:
			0px;
		width:
			100%;
		opacity:
			0;
		transition:
			opacity 0.8s ease-in-out,
			height 0.8s ease-in-out,
			transform 0.8s ease-in-out;
}

	.hidden-text {
		position:
			absolute;
		left:
			-100%;
		bottom:
			-50px;
		opacity:
			0;
		transition:
			opacity 0.8s ease-in-out,
			transform 0.8s ease-in-out,
			left 0.8s ease-in-out,
			bottom 0.8s ease-in-out;
		transform: translateX(-100%);
}

	/* Hardcoded positions for each image */
	.chip-green-1 {
		width: 15%;
		top: 25%;
		left: 15%;
	}

	.chip-green-2 {
		width: 25%;
		top: 10%;
		right: 25%;
	}

	.chip-yellow-1 {
		width: 12%;
		top: 35%;
		left: 35%;
	}

	.chip-yellow-2 {
		width: 12%;
		top: -5%;
		left: 70%;
	}

	.chip-yellow-3 {
		width: 12%;
		top: 10%;
		left: 35%;
	}

	.chip-yellow-4 {
		width: 12%;
		top: 35%;
		left: 65%;
	}

	.diamond-blue {
		width: 30%;
		top: 0%;
		left: -10%;
	}

	.diamond-yellow {
		width: 40%;
		top: 5%;
		right: -10%;
	}

	.top-card-container:hover img {
		transition: all 0.8s ease-in-out;
	}

	/* Estados de animación final cuando hay hover */
	.top-card-container:hover .chip-green-1 {
		transform: translate(-70px, 40px) scale(2) rotate(-40deg);
		opacity: 0;
	}

	.top-card-container:hover .chip-green-2 {
		transform: translate(30px, -50px) scale(2) rotate(20deg);
	}

	.top-card-container:hover .chip-yellow-1 {
		transform: translate(10px, -40px) scale(1.2) rotate(30deg);
		opacity: 0.9;
	}

	.top-card-container:hover .chip-yellow-2 {
		transform: translate(20px, -30px) scale(1.5) rotate(90deg);
		opacity: 0;
	}

	.top-card-container:hover .chip-yellow-3 {
		transform: translate(-70px, 10px) scale(1.8) rotate(-20deg);
	}

	.top-card-container:hover .chip-yellow-4 {
		transform: translate(60px, -40px) scale(1.7) rotate(40deg);
	}

	.top-card-container:hover .diamond-blue {
		transform: translate(70px, -50px) scale(0.8) rotate(20deg);
	}

	.top-card-container:hover .diamond-yellow {
		transform: translate(20px, -40px) scale(1.4) rotate(50deg);
		opacity: 0;
	}

	.top-card-container:hover .description-container-hidden {
		margin-bottom:
			0.5rem;
		display:
			flex;
}

	@media (min-width: 1024px) {

		.top-card-container:hover .description-container-hidden {
				height:
			50px;
				opacity:
			1;
		}
}

	.top-card-container:hover .description-container-hidden {
		transform: translateY(0);
	}

	.top-card-container:hover .hidden-text {
		left:
			0px;
		bottom:
			0px;
		opacity:
			1;
		transform: translateX(0);
}

	.top-card-container img {
		transition: all 0.8s ease-in-out;
		transform: translate(0) scale(1);
	}

	.chip-green-2,
	.chip-yellow-2,
	.chip-yellow-3,
	.chip-yellow-4,
	.diamond-yellow,
	.diamond-blue {
		opacity: 1;
	}

	.chip-green-1,
	.chip-yellow-1,
	.chip-yellow-4 {
		opacity:
			0.6;
}

	@media (min-width: 768px) {

		.chip-green-1,
	.chip-yellow-1,
	.chip-yellow-4 {
				opacity:
			1;
		}
}

	.text-with-shadow {
		text-shadow: 0px 0px 7px rgba(0, 0, 0, 0.5);
	}

	.hide-mobile {
		display:
			none;
		flex-direction:
			column;
}

	@media (min-width: 640px) {

		.hide-mobile {
				display:
			flex;
		}
}

	.card-section-title {
		margin-bottom:
			0.5rem;
		font-size:
			14px;
		font-weight:
			700;
		line-height:
			16px;
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family:
			var(--font-alternative-2);
}

	@media (min-width: 640px) {

		.card-section-title {
				font-size:
			24px;
				line-height:
			26px;
		}
}

	@media (min-width: 1280px) {

		.card-section-title {
				font-size:
			22px;
				line-height:
			24px;
		}
}

	.card-section-subtitle {
		max-width:
			60%;
		font-size:
			9px;
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1));
		font-family:
			var(--font-alternative-2);
}

	@media (min-width: 640px) {

		.card-section-subtitle {
				font-size:
			14px;
		}
}

	@media (min-width: 1280px) {

		.card-section-subtitle {
				font-size:
			14px;
		}
}

	.card-section-subtitle {
		text-shadow: 0px 1px 2px rgba(0, 0, 0, 0.5);
	}

	.card-section-body {
		font-size:
			8px;
		--tw-text-opacity:
			1;
		color:
			rgb(255 255 255 / var(--tw-text-opacity, 1));
		opacity:
			0.9;
		font-family:
			var(--font-alternative-2);
}

	@media (min-width: 640px) {

		.card-section-body {
				font-size:
			10px;
		}
}

	@media (min-width: 1280px) {

		.card-section-body {
				font-size:
			11px;
		}
}
</style>
